import atoms from "../../../../atoms";
import AddStorePermission from "./AddStorePermision";
import { TStaffPermissionStep } from "./interface";

const {Select} = atoms

const StaffPermissionStep = ({
  defaultPermission,
  structuredPermission,
  setStoreDetails,
  setDefaultPermission,
  permissionHeading,
  handleSelectedRole,
  rolesList,
  selectedRole
}: TStaffPermissionStep) => {
  return (
    <div>
      <div className="row mb-4">
        <div className="col-4">
          <Select
            type={"text"}
            className={"w-100"}
            options={rolesList}
            value={selectedRole}
            onChange={(e:React.MouseEvent<HTMLDivElement>) => handleSelectedRole(e)}
            placeholder={"Select"}
            label={"Select Role"}
          />
        </div>
        <div className="col-8"></div>
      </div>
      <div>
      <AddStorePermission
        defaultPermission={defaultPermission}
        structuredPermission={structuredPermission}
        setStoreDetails={setStoreDetails}
        setDefaultPermission={setDefaultPermission}
        permissionHeading={permissionHeading}
        permissionKey="staff_permissions"
      />
      </div>
    </div>
  );
};

export default StaffPermissionStep;
